import { memo, ReactElement } from "react"
import styled from "styled-components"
import Heading from "components/Typography/Heading"
import { useAppSelector } from "reducers/store"
import { useQueryState } from "context/queryState"
import ApiMetrics from "api/ApiMetrics"
import { CHARTS_FETCH } from "reducers/metrics/metrics-types"
import MetricsChart from "./MetricsChart"
import EventsBreakdownChart from "./EventsBreakdownChart"

interface ContainerProps {
  direction?: string
  align?: string
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.palette.gray_ice};
`

export const Title = styled.span`
  display: flex;
  align-items: center;
  padding: 40px 0px 24px 0px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px 24px 0px;

  @media (min-width: 1400px) {
    flex-direction: row;
    flex-wrap: wrap;

    > * {
      flex: 1;
      min-width: 0;

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
`

interface MetricsChartsProps {
  filters: App.MetricsParams
}

const MetricsCharts = (props: MetricsChartsProps): ReactElement => {
  const { filters } = props

  const searchFilters = {
    dateStart: filters.dateStart,
    dateEnd: filters.dateEnd,
    productPrefixUrl: filters.productPrefixUrl
  }

  useQueryState(
    [CHARTS_FETCH, searchFilters],
    async () =>
      new ApiMetrics().searchMetricsCharts({
        ...filters
      }),
    CHARTS_FETCH
  )

  const { data } = useAppSelector((state) => state.metrics.charts)

  const { netBalance, newAccounts, events } = data

  return (
    <>
      <Container direction="column" align="center">
        <Title>
          <Heading variant="h4">Tendência temporal</Heading>
        </Title>
        <Content>
          <MetricsChart title="Receita gerada no período" chartData={netBalance} isPrice />
          <MetricsChart title="Novas contas" chartData={newAccounts} />
        </Content>
      </Container>
      <Container direction="column" align="center">
        <Title>
          <Heading variant="h4">Eventos</Heading>
        </Title>
        <Content>
          <EventsBreakdownChart title="Eventos totais" chartData={events} />
        </Content>
      </Container>
    </>
  )
}

export default memo(MetricsCharts)
